module.exports = __webpack_public_path__ + "img/skill-7.b4e73eb2.svg";